export const DEFAULT_WARNINGS = [
    {
        id: 'default-1',
        header: 'Konštrukčné problémy vlekov',
        text: 'Vážení návštevníci, veľmi nás to mrzí, ale nakoľko vlek je technické zariadenie, musí byť mazané a pri odmäkových teplotách sa môže v malom množstve uvoľňovať mazivo aj s vyzrážanou vodou zo závesu a tým môže prísť k znečisteniu lyžiarskeho odevu. S týmto problémom bojujú viaceré lyžiarske strediská a vopred sa chceme ospravedlniť, ale tento problém nie je náš, je konštrukčný. Odporúčame tmavé lyžiarske nohavice. Za pochopenie vopred ďakujeme',
        createdAt: '2022-12-01T00:00:00.000Z'
    },
    {
        id: 'default-2',
        header: 'Zákon prikazuje!',
        text: "Podľa novely Zákona c. 544/2002 Z.z. o HZS, § 8a je ,,lyžiar mladší ako 15 rokov povinný na lyžiarskej trati chrániť si hlavu riadne upevnenou ochrannou prilbou''.",
        createdAt: '2022-12-01T00:00:00.000Z'
    }
];
